/*
 * Where: src/constants/readPageContent.js
 * What: Static content for the read page.
 * Why: Keep read-page copy separate from UI logic.
 */

export const READ_HERO = {
    badge: '読み取り',
    title: 'カードを読み取り、受給候補を確認します。',
    description:
        'このページではマイナンバーカードの読み取りと確認処理を行います。' +
        ' USB NFC4連携には拡張機能とNative Host設定が必要です。' +
        ' 申請手続きには進まず、受けられる行政サービスの確認のみを提供します。',
};
